import { create } from 'zustand';
import { createWordEditorSlice, WordEditorSlice } from './slices/wordEditor';
import { devtools } from 'zustand/middleware';

export interface WordEditorStoreState {
  customTags: WordEditorSlice;
}

const createWordEditorStore = (
  set: any,
  get: any,
  store: any,
): WordEditorStoreState => ({
  customTags: createWordEditorSlice(set, get, store),
});

export const useWordEditorStore = create<WordEditorStoreState>()(
  devtools(createWordEditorStore, {
    name: 'word-editor-store',
    enabled: process.env.NODE_ENV === 'development',
  }),
);
